module.exports = __webpack_public_path__ + "img/volvo.e69a6abd.svg";